







































































































import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { ContractsModule } from "@/store/contracts.module";
import { AuthModule } from "@/store/auth.module";
import QuestionDet from "./QuestionDet.vue";
import {
  Answers,
  Questionnaire,
  QuestionnaireDetails,
  SendAnswersDTO,
} from "~/contractinfo.type";

@Component({
  components: { QuestionDet },
})
export default class QuestionnaireDialog extends Mixins(FormValidator) {
  loading: boolean = false;
  formRef = "form";
  curQ: number = 1;

  checkForward() {
    if (!this.validateForm()) return;
    this.curQ++;
  }

  get progr() {
    return (100.0 * this.curQ) / this.qCount;
  }

  get user() {
    return AuthModule.user as IUser;
  }

  get question() {
    return this.qCount > 0
      ? ContractsModule.questionsList[this.curQ - 1]
      : (null as any);
  }

  get quertionNumber() {
    return this.$t("questionnaire.question-number", {
      num: this.curQ,
      count: this.qCount,
    });
  }

  get qCount() {
    return ContractsModule.questionsList.length;
  }

  get showQuestionnaire() {
    return ContractsModule.showQuestionnaire;
  }

  async closeDialog() {
    ContractsModule.setshowQuestionnaire(false);
  }
  async send() {
    try {
      if (AuthModule.user && AuthModule.user.bin) {
        if (!this.validateForm()) return;
        this.loading = true;
        let result: Answers[] = [];
        ContractsModule.questionsList.forEach((element: Questionnaire) => {
          result = result.concat(
            element.rqd.map((x: QuestionnaireDetails) => {
              return { var_rid: x.var_rid, checked: x.checked, text: x.text };
            }),
          );
        });
        const a: SendAnswersDTO = {
          bin: AuthModule.user.bin,
          answers: result,
        };
        await ContractsModule.sendAnswers(a);
        await this.closeDialog();
        if (AuthModule.user && AuthModule.user.bin)
          await ContractsModule.getQuestionnaire(AuthModule.user.bin);
        this.loading = false;
      } else {
        await this.$router.push("/auth");
      }
    } finally {
      this.loading = false;
      //
    }
  }
}
